/**
 * Custom Fields Manager
 * Handles storage and retrieval of custom fields configuration
 */

const STORAGE_KEY = 'property_custom_fields';

/**
 * Get custom fields from localStorage
 * @returns {Array} Array of custom field definitions
 */
export const getCustomFields = () => {
  try {
    const stored = localStorage?.getItem(STORAGE_KEY);
    return stored ? JSON?.parse(stored) : [];
  } catch (error) {
    console.error('Error loading custom fields:', error);
    return [];
  }
};

/**
 * Save custom fields to localStorage
 * @param {Array} fields - Array of custom field definitions
 */
export const saveCustomFields = (fields) => {
  try {
    localStorage?.setItem(STORAGE_KEY, JSON?.stringify(fields));
    return true;
  } catch (error) {
    console.error('Error saving custom fields:', error);
    return false;
  }
};

/**
 * Get custom fields by category
 * @param {string} category - Category name (details, location, owner, pricing, contracts, reports, other)
 * @returns {Array} Filtered array of custom fields
 */
export const getCustomFieldsByCategory = (category) => {
  const allFields = getCustomFields();
  return allFields?.filter(field => field?.category === category);
};

/**
 * Add custom field values to property data
 * @param {Object} propertyData - Property data object
 * @param {Object} customFieldValues - Custom field values
 * @returns {Object} Property data with custom fields
 */
export const mergeCustomFieldsWithProperty = (propertyData, customFieldValues = {}) => {
  return {
    ...propertyData,
    customFields: customFieldValues
  };
};

/**
 * Extract custom field values from property data
 * @param {Object} propertyData - Property data object
 * @returns {Object} Custom field values
 */
export const extractCustomFieldValues = (propertyData) => {
  return propertyData?.customFields || {};
};

/**
 * Validate custom field values
 * @param {Array} fieldDefinitions - Array of field definitions
 * @param {Object} values - Field values to validate
 * @returns {Object} Validation errors object
 */
export const validateCustomFields = (fieldDefinitions, values) => {
  const errors = {};
  
  fieldDefinitions?.forEach(field => {
    if (field?.required && !values?.[field?.id]) {
      errors[field?.id] = `${field?.label} مطلوب`;
    }
  });
  
  return errors;
};